import { nodeListToArray } from '../helpers/nodeListToArray';

export class thumbnailCheck {
    thumbnailContainers: Array<any>;
    hiresClass: string;
    lowresClass: string;

    constructor() {
        this.lowresClass = "youtube-lowres"
        window.addEventListener('load', this.checkRes.bind(this));
    }

    checkRes() {
        this.thumbnailContainers = nodeListToArray(document.querySelectorAll('[data-youtube-thumbs]'));

        //Check width of hires image. If available, set hires to display
        this.thumbnailContainers.forEach(thumbContainer => {
            let hiresImg = thumbContainer.querySelector('.hi-res-thumb');
            let lowresImg = thumbContainer.querySelector('.lo-res-thumb');
            let hiresImgWidth = hiresImg.naturalWidth as Number;

            if (hiresImgWidth < 140) {
                hiresImg.style.display = "none";
                thumbContainer.classList.add("youtube-lowres");
            }
            else {
                lowresImg.style.display = "none";
                thumbContainer.classList.add("youtube-highres");

            }

        })
    }

}